module.exports = __webpack_public_path__ + "72bfc5058ee11ce1fcbac6bdb4e728dd.fbx";